import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwapVertIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swap_vert"}/>
}
